import React from "react";
import BillingHistoryMobileTransactionContainer from "../../containers/ProfileMobileContainer/BillingHistoryMobileTransactionContainer";

const BillingHistoryMobileTransactionPage = () => {
    return <BillingHistoryMobileTransactionContainer />
}

export default BillingHistoryMobileTransactionPage;